import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the user clicks the CTA on the Worker Type pop-up.
 * Event: dental_portal:office_signup:worker_type_popup_confirmed
 */
export function fireWorkerTypePopupConfirmed(): void {
  PosthogService.getInstance().track('dental_portal:office_signup:worker_type_popup_confirmed', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
